export var Priority;
(function (Priority) {
    Priority[Priority["HIGHEST"] = 1] = "HIGHEST";
    Priority[Priority["HIGH"] = 2] = "HIGH";
    Priority[Priority["NORMAL"] = 3] = "NORMAL";
    Priority[Priority["LOW"] = 4] = "LOW";
    Priority[Priority["LOWEST"] = 5] = "LOWEST";
})(Priority || (Priority = {}));
//# sourceMappingURL=priority.js.map